import { Route } from 'vue-router';

export const hasOnlyAdminMeta = (route: Route): boolean => route?.meta?.only_admin;

export const hasRequiresPatientMeta = (route: Route): boolean => route?.meta?.requiresPatient;

export const hasForbiddenPatientMeta = (route: Route): boolean => route?.meta?.forbiddenPatient;
